(function () {
    'use strict';

    function registrationDataService($http) {

        var baseUrl = '[BuildifyApiHost]/api/';

        function getRegistrationOptions() {
            return $http.get(baseUrl + 'registrationconfiguration').then(function (response) {
                return response.data;
            });
        };

        function registerEntity(entity) {
            return $http.post(baseUrl + 'register', entity).then(function (response) {
                return response.data;
            });
        }

        return {
            getRegistrationOptions: getRegistrationOptions,
            registerEntity: registerEntity
        }
    }

    registrationDataService.$inject = ['$http'];

    angular.module('ecap.registration').service('registrationDataService', registrationDataService);
})();
